 <div *ngIf="isLoggedIn">
 <!-- <header [title]="title" (reloadPage)="reloadPage()"></header> -->
 
    <content [ngClass]="{ 'no-footer': !showFooter, 'with-header': isMetricsPage() }">
        <router-outlet></router-outlet>
    </content>
 
    <footer *ngIf="showFooter"></footer>
</div>
 
<div *ngIf="!isLoggedIn && !isLoading">
    <content>
        <router-outlet></router-outlet>
    </content>
</div>
 
<div *ngIf="modal" class="modal-window">
    <div class="locked"></div>
    <ng-container [ngComponentOutlet]="modal.type" [ndcDynamicInputs]="modal.inputs" [ndcDynamicOutputs]="modal.outputs"></ng-container>
</div>
 
<access *ngIf="layoutCssClass === 'noaccess'"></access>
<error *ngIf="error !== ''" [message]="error"></error>
 
<div *ngIf="showAlert" class="modal-window">
    <div class="locked"></div>
    <alert
        [title]="alertTitle"
        [message]="alertMessage"
        [continueText]="alertContinueText"
        [cancelText]="alertCancelText"
        (continueEvent)="alertContinue()"
        (cancelEvent)="alertCancel()"></alert>
</div>
 
<sdk-loading [isLoading]="isLoading"></sdk-loading>
 